module.exports = __webpack_public_path__ + "img/no_change_white_32dp.abe614e6.png";